import { useQuery } from 'query';
import { loadIO } from 'scenes/FinancePage/IO/sources';

import { details } from './queryKeyFactory';

export const useLoadIO = ({ id }: { id: number }) => {
  return useQuery(details({ id }), async () => {
    return loadIO({ id });
  });
};
